import React from "react";
import styles from "./ParticipatingUniversities.module.scss";
import CustomImage from "../../CustomImage";
import { useRouter } from "next/router";
import useZipmeLink from "../../../hooks/useZipmeLink";
import { isFrappeOrJotFormClass } from "../../../utils/helpers";

interface Props {
  universitydata: any;
  univertitle: any;
  universitybackcolor: any;
}

const ParticipatingUniversities: React.FC<Props> = ({ universitydata, univertitle, universitybackcolor }) => {
  const router = useRouter();
  const { generateLink } = useZipmeLink();

  return (
    <>
      <div className={styles.universitiesSection} style={{ backgroundColor: universitybackcolor || "#F2F8FF" }}>
        <div className={styles.sectionContainer}>
          <div className={styles.sectionHeading}>
            <h2>{univertitle}</h2>
          </div>
        </div>
        {router.pathname.includes("/company/") ? null : (
          <div className={styles.sectionContainer}>
            <div className={styles.universitiesList}>
              <div className={styles.cardsGrid}>
                {universitydata?.length > 0 &&
                  universitydata?.map((universitydetails: any, index: number) => {
                    return (
                      <div key={index} className={styles.cardWrapper}>
                        <div className={styles.universityCard}>
                          <div className={styles.cardImageWrapper}>
                            <CustomImage
                              src={universitydetails?.cardImage?.imageUrl || "/images/admissionsday/universitya.png"}
                              width={316}
                              height={180}
                              className={styles.cardImage}
                              alt="University-Representative.png"
                            />
                          </div>
                          <div className={styles.cardBody}>
                            <div className={styles.universityName}>
                              <h4>{universitydetails?.cardUniversityName?.label}</h4>
                            </div>
                            <div className={styles.universitySubtitle}>
                              <h4>{universitydetails?.cardUniversityName?.value}</h4>
                            </div>
                            <div className={styles.detailsRow}>
                              {universitydetails?.cardDetails?.length > 0 &&
                                universitydetails?.cardDetails?.map((cardtext: any, detailIndex: number) => {
                                  return (
                                    <React.Fragment key={detailIndex}>
                                      <div className={styles.detailLabel}>{cardtext?.label}</div>
                                      <div className={styles.detailValue}>{cardtext?.value}</div>
                                    </React.Fragment>
                                  );
                                })}
                            </div>
                            <div className={styles.registerButtonWrapper}>
                              <button
                                type="button"
                                onClick={() => {
                                  if (!universitydetails?.jotformId) {
                                    generateLink(universitydetails?.externalLink ?? "");
                                  }
                                }}
                                className={`${styles.registerButton} ${universitydetails?.jotformId ? `${isFrappeOrJotFormClass(universitydetails?.jotformId)}` : ""}`}
                              >
                                {router.pathname.includes("/company/") ? "Apply Now" : "Register Now"}
                              </button>
                              <script
                                dangerouslySetInnerHTML={{
                                  __html: `window.lintrk('track', { conversion_id: 6870956 });`,
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
export default ParticipatingUniversities;
